import { Fragment, FormEvent } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Team from "../../api/team";
import arrow from "../../images/arrow.svg";
import Footer from "../../components/footer/Footer";

type RouteParams = {
    slug?: string;
};

type TeamItem = {
    id: string | number;
    tImg: string;
    name: string;
    slug: string;
    title?: string;
};

const TeamSinglePage: React.FC = () => {
    const { slug } = useParams<RouteParams>();

    const teamDetails: TeamItem | undefined = (Team as TeamItem[]).find(
        (item) => item.slug === slug
    );

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // handle form submission here
    };

    // Fallback UI if no team found
    if (!teamDetails) {
        return (
            <Fragment>
                <Navbar hclass="wpo-header-style-1" />
                <PageTitle pageTitle="Team Member Not Found" pagesub="Team" />
                <div className="team-pg-area section-padding">
                    <div className="container-fluid">
                        <div className="team-info-wrap">
                            <div className="row align-items-center">
                                <div className="col-12">
                                    <p style={{ textAlign: "center", margin: "40px 0" }}>
                                        We couldn’t find the requested team member.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer footerClass="wpo-site-footer-s1" />
                <Scrollbar />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <Navbar hclass="wpo-header-style-1" />
            <PageTitle pageTitle={teamDetails.name} pagesub={teamDetails.title ?? "Team"} />

            <div className="team-pg-area section-padding">
                <div className="container-fluid">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <img src={teamDetails.tImg} alt={teamDetails.name} />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2 className="poort-text poort-in-right">{teamDetails.name}</h2>
                                    <ul>
                                        <li>
                                            <span>Position:</span>
                                            <span>Planner</span>
                                        </li>
                                        <li>
                                            <span>Planner Service:</span>
                                            <span>Photography, Wedding Ceremony</span>
                                        </li>
                                        <li>
                                            <span>Experience:</span>
                                            <span>12 Years</span>
                                        </li>
                                        <li>
                                            <span>Address:</span>
                                            <span>Millington, Ave, TN 38053</span>
                                        </li>
                                        <li>
                                            <span>Phone:</span>
                                            <span>+00 568 746 987</span>
                                        </li>
                                        <li>
                                            <span>Email:</span>
                                            <span>youremail@gmail.com</span>
                                        </li>
                                        <li>
                                            <span>Fax:</span>
                                            <span>568 746 987</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="exprience-area">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="exprience-wrap ex-wiget">
                                    <h2>Personal Experience</h2>
                                    <p>
                                        <span>M</span>odern Weddings are timeless celebrations of love, carrying
                                        traditions that have flourished for centuries while embracing the beauty
                                        of modern design. Just as love has endured through generations, weddings
                                        have gracefully evolved—blending classic elegance with fresh, contemporary
                                        touches.
                                    </p>
                                    <p>
                                        From heartfelt vows to unforgettable décor, every element is carefully
                                        crafted to reflect the couple’s unique story. A wedding is not just a day,
                                        but a cherished memory that lives on, beautifully preserved in moments of
                                        joy, laughter, and togetherness.
                                    </p>
                                </div>

                                <div className="education-area ex-wiget">
                                    <h2>Education</h2>
                                    <ul>
                                        <li>
                                            <img src={arrow} alt="" />
                                            <span>
                                                There are many variations of passages of Lorem Ipsum available, but the
                                                majority have suffered alteration in some form, by injected humour.
                                            </span>
                                        </li>
                                        <li>
                                            <img src={arrow} alt="" />
                                            <span>If you are going to use a passage of Lorem Ipsum.</span>
                                        </li>
                                        <li>
                                            <img src={arrow} alt="" />
                                            <span>Very popular during the Renaissance.</span>
                                        </li>
                                        <li>
                                            <img src={arrow} alt="" />
                                            <span>Many desktop publishing packages and web page editors now.</span>
                                        </li>
                                    </ul>
                                </div>

                                <div className="language-area ex-wiget">
                                    <h2>Language</h2>
                                    <ul>
                                        <li>French (fluent), English (fluent), Greek, Chinese.</li>
                                    </ul>
                                </div>

                                <div className="wpo-contact-area ex-wiget">
                                    <div className="quote-form">
                                        <h2>Contact With Me.</h2>
                                        <form
                                            method="post"
                                            className="contact-validation-active"
                                            id="contact-form"
                                            onSubmit={handleSubmit}
                                        >
                                            <div className="form-group half-col">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Name:"
                                                    name="name"
                                                    id="name"
                                                />
                                            </div>
                                            <div className="form-group half-col">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Email:"
                                                    name="email"
                                                    id="email"
                                                />
                                            </div>
                                            <div className="form-group half-col">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Subject:"
                                                    name="subject"
                                                    id="subject"
                                                />
                                            </div>
                                            <div className="form-group half-col">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Your Address:"
                                                    name="address"
                                                    id="address"
                                                />
                                            </div>
                                            <div className="form-group full-col">
                                                <textarea
                                                    className="form-control"
                                                    name="note"
                                                    placeholder="Description..."
                                                />
                                            </div>
                                            <div className="form-group full-col text-center">
                                                <div className="team-btn">
                                                    <button className="theme-btn" type="submit">
                                                        Get In Touch
                                                    </button>
                                                </div>
                                                <div id="loader">
                                                    <i className="ti-reload" />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                {/* end contact area */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer footerClass="wpo-site-footer-s1" />
            <Scrollbar />
        </Fragment>
    );
};

export default TeamSinglePage;
